/* ==========================================================
   BLZ CLINIC — PDP V11 SAFE
   ----------------------------------------------------------
   Este arquivo NÃO move quantidade, variante ou formulário.
   O layout da compra é controlado diretamente por
   sections/main-product.liquid.
   ========================================================== */

(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function hideLeakedShippingCode(root) {
    if (!root) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    const matches = [];
    let node;

    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style')) continue;

      const text = normalize(node.nodeValue);
      const leaked =
        text.includes('VAR THRESHOLD') ||
        text.includes('THRESHOLD = 19900') ||
        (
          text.includes('DOCUMENT.QUERYSELECTOR') &&
          text.includes('BLZ-SHIP') &&
          text.includes('FETCH(')
        );

      if (leaked) matches.push(node);
    }

    matches.forEach(function (textNode) {
      textNode.nodeValue = '';
    });
  }

  function init() {
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (!mainProduct) return;

    document.body.classList.add('blz-pdp-brae-ready');
    hideLeakedShippingCode(mainProduct);

    console.log(
      '[BLZ PDP V11] Layout de compra controlado pelo main-product.liquid.'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 80);
  });
})();
